import React from "react";
import styled from "styled-components";
import { SecondaryButton } from "./Button";
import { ButtonCheck } from "./Checkbox";

export interface CustomTableProps {
  items: Array<any>;
  headers: Array<any>;
  actionLabel?: string;
  icon?: string;
  showHeaders?: boolean;
  emptyString?: string;
  onActionClick?: (parameter: any) => void;
  onNotificationClick?: (parameter: any) => void;
}

const Custom = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 2rem;
  @media only screen and (max-width: 768px) {
    margin-top: 0rem;
  }

  td {
    color: #4d4d4d;
    text-align: center;
    padding: 1.3rem;
    min-width: 4rem;
  }
  thead {
    margin-bottom: 1rem;
  }
  thead tr {
    height: 3.6rem;
    text-align: center;
    color: #052e6d;
    background: #ffffff;
    box-shadow: 0px 2px 10px #00000010;
    border: 1px solid #e8e8e8;
  }
  tbody tr {
    border: 1px solid #e8e8e8;
  }
  tr:nth-child(even) {
    background-color: #f3f3f3;
  }
  tr:nth-child(odd) {
    background-color: #ffffff;
  }
`;

const Basic = styled.table`
  width: 100%;
  border-collapse: collapse;
  tbody.striped {
    border: solid 1px #e8e8e8;
    tr:nth-child(even) {
      background-color: #f3f3f3;
    }
    tr:nth-child(odd) {
      background-color: #ffffff;
    }
    td {
      padding: 1.3rem;
    }
  }
  thead tr {
    height: 3rem;
    color: #052e6d;
  }
  tbody tr {
    border-bottom: solid 1px #e8e8e8;
  }
  td {
    color: #838383;
    text-align: center;
  }
`;

const Empty = styled.div`
  font-size: 1.2rem;
  text-align: center;
`;

const Notification = styled.a`
  color: "black";
  cursor: pointer;
  text-decoration: none;
`;

const templateRow = (
  row: any,
  header: any,
  actionLabel: string,
  icon: string,
  onButtonClick: any,
  onLinkClick?: any,
) => {
  const element = row[header.id];
  if (typeof element === "boolean") {
    if (header.id === "notifications") {
      return (
        <Notification>
          {element ? (
            <ButtonCheck
              checked={true}
              label="Notificacion activada"
              onCheckboxChanged={(a) => onLinkClick({ row: row, checked: a })}
            />
          ) : (
            <ButtonCheck
              checked={false}
              label="Activar notificaciones"
              onCheckboxChanged={(a) => onLinkClick({ row: row, checked: a })}
            />
          )}
        </Notification>
      );
    } else return element ? "Si" : "No";
  } else if (header.id === "action") {
    return (
      <SecondaryButton
        onClick={() => onButtonClick(row)}
        text={actionLabel ? actionLabel : ""}
        svg={icon}
      />
    );
  } else if (header.id === "lcod" || header.id === "code") {
    return (
      <span
        style={{
          color: "#dd052b",
          borderRadius: "5px",
          border: "solid 1px #dd052b",
          padding: "0.4rem 1.2rem",
        }}
      >
        {element}
      </span>
    );
  } else return element;
};

export const CustomTable: React.FC<CustomTableProps> = ({
  items,
  headers,
  actionLabel,
  icon,
  onActionClick,
  onNotificationClick,
}) => (
  <>
    <Custom>
      <tbody>
        {items.map((row: any, index: number) => {
          return (
            <tr key={index}>
              {headers.map((header: any, i: number) => {
                return (
                  <td key={i}>
                    {templateRow(
                      row,
                      header,
                      actionLabel,
                      icon,
                      onActionClick,
                      onNotificationClick,
                    )}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </Custom>
  </>
);

export const BasicTable: React.FC<CustomTableProps> = ({
  items,
  headers,
  actionLabel,
  icon,
  showHeaders,
  emptyString,
  onActionClick,
}) => (
  <>
    {items && items.length ? (
      <Basic>
        {showHeaders ? (
          <thead>
            <tr>
              {headers.map((h: any, index: number) => {
                return <th key={index}>{h.label}</th>;
              })}
            </tr>
          </thead>
        ) : null}
        <tbody className={actionLabel ? "" : "striped"}>
          {items.map((row: any, index: number) => {
            return (
              <tr key={index}>
                {headers.map((header: any, i: number) => {
                  return (
                    <td key={i}>
                      {templateRow(
                        row,
                        header,
                        actionLabel,
                        icon,
                        onActionClick,
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Basic>
    ) : (
      <Empty>{emptyString}</Empty>
    )}
  </>
);
